import { useWindowSize, WEBSITE_BREAKPOINTS } from '@platform/utils'

import LargeCards from './large'
import MediumCards from './medium'
import SmallCards from './small'

// Const
const Cards = () => {
  const { windowWidth } = useWindowSize()

  const isDesktop = windowWidth && windowWidth > WEBSITE_BREAKPOINTS.MEDIUM
  const isMobile = windowWidth && windowWidth <= WEBSITE_BREAKPOINTS.SMALL

  return (
    <>
      {isDesktop && <LargeCards key="large-card" />}
      {!isMobile && !isDesktop && <MediumCards key="medium-card" />}
      {isMobile && <SmallCards key="small-card" />}
    </>
  )
}

export default Cards
